import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=552c226c&scoped=true"
import script from "./SearchButton.ts?vue&type=script&lang=ts&external"
export * from "./SearchButton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c226c",
  null
  
)

export default component.exports